module.exports = __webpack_public_path__ + "static/media/Bedroom5-2.1719b9c5.jpg";